// @ts-nocheck
import ErrorPage from "@/components/ErrorPage";
export default function ErrorView() {
  const [searchParams] = useSearchParams();
  const getSearchParam = (paramKey: string) => {
    return decodeURIComponent(searchParams.get(paramKey));
  };
  const errorMessage = getSearchParam("errorMessage");
  const navigate = useNavigate();
  function handleGoBack() {
    navigate(-1);
  }
  return <ErrorPage errorMessage={errorMessage} refreshPage={() => handleGoBack()} />;
}
